import { useRef } from 'react';

/** A ref mirroring `value` on every render — for reading the current value inside async callbacks. */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
